<template>
  <section class="fa-table team-table py2 sans border-top mx-auto">
    <h3 class="sm-hide md-hide lg-hide mb3 red">{{ title }}</h3>
    <div class="row clearfix mxn2">
      <div class="col xs-hide sm-col-4 px2">{{ title }}</div>
      <div class="col col-12 sm-col-8 px2">
        <div v-for="(item, index) in content"
          class="hover-red row clearfix mb2 mxn2" :key="index">
          <router-link :to="{ name: routeName, params: { slug: item.post_name }}">
            <div class="col col-6 relative px2">
              <span class="hide-print badge caps absolute" v-if="dateIsBefore(item.start.date)">Upcoming</span>
              <span class="hide-print badge caps absolute red" v-else-if="dateIsBefore(item.end.date)">Now</span>
              <span class="tabular">
                {{ formatDate(item.start.date) }}<span v-if="item.end.date"> – {{ formatDate(item.end.date) }}</span>
              </span>
            </div>
            <div class="col col-6 px2">
              <em>{{ item.post_title }}</em><br/>
              {{ item.venue }}
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatDate } from '@/utils'

export default {

  name: 'ExhibitionTable',

  data () {
    return {

    }
  },

  props: ['title', 'content', 'linkRoot'],

  computed: {
    routeName () {
      if (this.title === 'Exhibitions') {
        return 'Exhibition'
      } else {
        return this.title
      }
    }
  },

  methods: {
    formatDate
  }
}
</script>

<style lang="css" scoped>
  .team-table {
    max-width: var(--max-width-med);
    line-height: var(--line-height-reader);
  }
  .badge {
    width: 64px;
    left: -96px;
    padding: 0 0.6em;
    border: 1px solid var(--black);
    text-align: center;
    border-radius: 8px;
    color: var(--black);

    &.red {
      color: var(--red);
      border-color: var(--red);
    }
  }
</style>
